import lookupMeta from 'rlink-data-connector/lookupMeta';
export default function timedExpiration (duration) {
  return (
      caches,
      request,
      requestArgs
  ) => {
    let {timestamp} = lookupMeta(caches, request, requestArgs);
    if (!timestamp) {
      return true;
    }
    return timestamp.valueOf() + (duration * 1000) < Date.now();
  };

}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/caching/timedExpiration.js